import Skeleton from '@material-ui/lab/Skeleton'

import useStyles from './styles/index.styles'

export const TemplateTimeIntervalSkeletonMobile = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.eachSeperatedRow}>
        <Skeleton
          variant="circle"
          animation="wave"
          className={classes.counterSkeleton}
        />
        <Skeleton animation="wave" width="10%" height={60} />
      </div>
      <div className={classes.root}>
        <div className={classes.eachSeperatedRow}>
          <Skeleton animation="wave" width="30%" height={20} />
          <Skeleton animation="wave" width="30%" height={20} />
        </div>

        <div className={classes.eachSeperatedRow}>
          <Skeleton animation="wave" width="30%" height={20} />
          <Skeleton animation="wave" width="30%" height={20} />
        </div>

        <div className={classes.eachSeperatedRow}>
          <Skeleton animation="wave" width="30%" height={20} />
          <Skeleton animation="wave" width="30%" height={20} />
        </div>

        <div className={classes.eachSeperatedRow}>
          <Skeleton animation="wave" width="30%" height={20} />
          <Skeleton animation="wave" width="30%" height={20} />
        </div>
      </div>
    </>
  )
}
